import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "helperMessage"];
import React from "react";
import Box from "../../Box";
import Stack from "../../Stack";
import PrimitiveSkeletonBox from "../primitives";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FormFieldSkeleton(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? "default" : _ref$type,
    helperMessage = _ref.helperMessage,
    boxProps = _objectWithoutProperties(_ref, _excluded);
  var inputHeight = type === "textarea" ? 95.99 : 32;
  return /*#__PURE__*/_jsx(Box, _extends({}, boxProps, {
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "sm",
      children: [/*#__PURE__*/_jsx(PrimitiveSkeletonBox, {
        height: 12,
        width: 100,
        maxWidth: "100%"
      }), /*#__PURE__*/_jsx(PrimitiveSkeletonBox, {
        height: inputHeight,
        width: "100%"
      }), helperMessage && /*#__PURE__*/_jsx(PrimitiveSkeletonBox, {
        height: 12,
        width: 200,
        maxWidth: "100%"
      })]
    })
  }));
}
export default FormFieldSkeleton;